import { render, staticRenderFns } from "./ExtraerReporte.vue?vue&type=template&id=8745b074&"
import script from "./ExtraerReporte.vue?vue&type=script&lang=js&"
export * from "./ExtraerReporte.vue?vue&type=script&lang=js&"
import style0 from "./ExtraerReporte.vue?vue&type=style&index=0&id=8745b074&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports